import { Button } from '@nesso/ui/primitives/button';
import { Card, CardDescription, CardTitle } from '@nesso/ui/primitives/card';

import { formatRelativeDays, formatShortDate } from '@/shared/lib/time-utils';

type DashboardExpiredTakeoverProps = {
    deletionDate?: string | null;
    onChoosePlan: () => void;
};

export function DashboardExpiredTakeover({
    deletionDate,
    onChoosePlan,
}: DashboardExpiredTakeoverProps) {
    const relativeDeletion = deletionDate ? ` ${formatRelativeDays(deletionDate)}` : '';
    const absoluteDeletion = deletionDate ? ` after ${formatShortDate(deletionDate)}` : '';

    return (
        <div className="flex flex-1 items-start justify-center p-4 pt-21.5">
            <Card className="max-w-158 items-center gap-6 px-6 pt-6 pb-8 text-center">
                <div className="flex size-24 items-center justify-center rounded-full bg-destructive-foreground">
                    <span
                        aria-hidden
                        className="text-[54px] font-bold leading-none text-destructive"
                    >
                        !
                    </span>
                </div>
                <div className="flex flex-col items-center gap-2">
                    <CardTitle>Your account will be deleted{relativeDeletion}</CardTitle>
                    <CardDescription>
                        To protect your clients, all notes, transcripts, and data associated with
                        your account will be deleted.{' '}
                        <span className="underline">Choose a new plan</span> to access to your notes{' '}
                        {absoluteDeletion}.
                    </CardDescription>
                </div>
                <Button onClick={onChoosePlan}>Choose a New Plan</Button>
            </Card>
        </div>
    );
}
